
export const environment = {
  env: 'staging',
  production: true,
  serverUrl: 'https://main.d39vr9xxu4aaee.amplifyapp.com',
  authMSServerUrl: 'https://app.dev.eyeqmarketplace.com/api/auth/v2',
  hereMaps: {
    appId: 'aVXQzioL3HEzswpmAdKP',
    apiKey: 'l0-GfDqF4mB4uPnwPnaysfihILMIT6SKqbpROZuQuak'
  },
  firebaseConfig: {
    apiKey: 'AIzaSyCXgFlF2qlknFDzErbKQ7aVgrZ7MZS1Eeg',
    authDomain: 'eyeqmarketplace-uat.firebaseapp.com',
    databaseURL: 'https://eyeqmarketplace-uat.firebaseio.com',
    projectId: 'eyeqmarketplace-uat',
    storageBucket: 'eyeqmarketplace-uat.appspot.com',
    messagingSenderId: '699931123933',
    appId: '1:130185129023:web:ef177e46474e2cc8a0dc8a',
    measurementId: 'G-FPSH1VCJB7'
  },
  firebaseVapidKey: 'BGL-WQQxJyqicVOII0Ug0s4LAFYz6P0hg396GIyjC33SQpIvrk-2HkCJ8Hye9MyFXyKzr6jEZFWI5nP1a8QL7R8',
  optimizely: {
    sdkKey: '9hasGRMTdRq3ArKfqNvF93',
    useLocalFeatureFlagJson: false,
	},
	marketplace: { jobExpireBeforeFirstStopInMinutes: '-60' },
	mixpanel: { token: 'd2dfd9ad35913a5ee9f58b4dfe014e20' },
	sentry: {
    enabled: true,
	  dsn: 'https://237daee7e810a07c4bfb92114f53a254@o4509333534736384.ingest.de.sentry.io/4510420413055056',
	  sampleRate: '1',
	  replaysSessionSampleRate: '1',
	  replaysOnErrorSampleRate: '1',
  },
  userFlowWebToken: 'ct_fulsgm3jtfgnri5u4fcq3el5ki',
  timeoutBeforeVerificationBannerInMs: undefined,
  zendeskWidgetId: 'undefined',
  zendeskCompanyNameFieldId: '12934966520477',
  project: 'undefined',
  projectEnvironment: 'undefined',
};
